export function lineBreaks(text: string): string {
        return text.replace(/\\n/g, '<br />');
}